<nav class="settings-menu">
    <ul class="settings-menu-list" data-testid="settings-menu">
        <menu-button [subtitle]="labels.account"
                     [isActive]="isAccountMenuButtonActive('account')"
                     (buttonClick)="switchMainLayout('account')">
        </menu-button>
        @if (settings.modules.length) {
            <menu-button [subtitle]="labels.modules"
                         [isOpen]="showModulesList()"
                         (buttonClick)="toggleModulesList()">
            </menu-button>
            @if (showModulesList()) {
                <ul class="settings-menu-list">
                    @for (module of settings.modules; track module.udid) {
                        <menu-button
                                [subtitle]="(module.id + 1) + '. ' + module.name"
                                [isModule]="true"
                                [isOpen]="isModuleOpen(module)"
                                [isSelected]="isModuleOpen(module)"
                                (buttonClick)="toggleModuleOptions(module)">
                        </menu-button>
                        @if (isModuleOpen(module)) {
                            <ul class="settings-menu-list selected-submenu border-company-color"
                                [class.selected-submenu--last]="$last">
                                @for (option of moduleOptions; track option.layout) {
                                    @if (option.isVisible(module)) {
                                        <menu-button
                                                [subtitle]="option.label"
                                                [isOption]="true"
                                                [isActive]="isModuleButtonActive(option.layout, module)"
                                                (buttonClick)="switchLayout(module.udid, option.layout)">
                                        </menu-button>
                                    }
                                }
                            </ul>
                        }
                    }
                </ul>
            }
        }
        @if (!settings.modules.length || showModulesList()) {
            <registration-button
                    [isModule]="settings.modules.length > 0"
                    [isActive]="isAccountMenuButtonActive('registration_new_module')"
                    (buttonClick)="openRegistrationForm()"
                    [subtitle]="labels.registration">
            </registration-button>
        }
        <menu-button [subtitle]="labels.manuals"
                     [isActive]="isAccountMenuButtonActive('manuals')"
                     (buttonClick)="switchMainLayout('manuals')">
        </menu-button>
    </ul>
</nav>
